import { Trans, useTranslation } from 'react-i18next';
import { DSLinkButton } from '@stihl-design-system/components';

import { link } from '@phoenix/core/frontend/shared/util/navigation/link.utils';
import { BaseBanner } from '@phoenix/team-m/dashboard/frontend/shared/components/base-banner';
import { LinkOut } from '@phoenix/core/frontend/shared/ui/link-out/link-out';
import { GA } from '@phoenix/core/frontend/shared/feature/google-analytics/ga';
import { useImpressionEvent } from '@phoenix/core/frontend/shared/util/hooks/use-impression-event';

interface WarrantyExtensionBannerProps {
  hasLinkButton?: boolean;
  termsUrl?: string;
  preffix?: 'addTool' | 'dashboard';
  trackEvents?: boolean;
}

export const WarrantyExtensionBanner: React.FC<WarrantyExtensionBannerProps> = ({
  hasLinkButton,
  termsUrl,
  preffix = 'addTool',
  trackEvents,
}) => {
  const { t } = useTranslation();
  const BASE_EVENT_NAME = `mystihl_banner_${preffix}_warranty_extension`;

  const headline = t(`${preffix}_bannerExtendWarranty_header`);

  const onAddToolClick = () => {
    trackEvents &&
      GA.sendEvent({
        event_name: `${BASE_EVENT_NAME}_link_click`,
        ...trackingData,
      });
  };

  const linkButton = hasLinkButton
    ? {
        url: link('tool-shed/add-tool'),
        label: t(`${preffix}_bannerExtendWarranty_buttonLabel`),
      }
    : undefined;

  const trackingData = {
    id: `${preffix}_warranty_extension_banner`,
    headline,
    description: t(`${preffix}_bannerExtendWarranty_description`),
    button_text: linkButton?.label,
    link_url: linkButton?.url,
  };

  const ref = useImpressionEvent(() => trackEvents && GA.sendEvent({ event_name: `${BASE_EVENT_NAME}_impression`, ...trackingData }));

  return (
    <BaseBanner
      ref={ref}
      id="warranty-extension-banner"
      backgroundImg="warranty-extension.webp"
      imageTags={['imagesToolShed', 'imagesDashboard']}
      headline={headline}
      description={
        termsUrl && (
          <Trans
            i18nKey={`${preffix}_bannerExtendWarranty_description`}
            components={{
              a: <LinkOut href={termsUrl} allowReferrer={true} />,
            }}
          />
        )
      }
    >
      {linkButton && (
        <DSLinkButton href={linkButton.url} onClick={onAddToolClick} iconName="plus" className="mt-5 w-full tablet:w-fit">
          {linkButton.label}
        </DSLinkButton>
      )}
    </BaseBanner>
  );
};

export default WarrantyExtensionBanner;
